import { FC, useEffect } from 'react'
import { SpinLoading } from 'antd-mobile'
import { unLoginVerify } from './index'
import { getUrlParam } from '@/utils'
import { useSelectRole } from '@/hooks/useSelectRole'
import { useStoreDispatch } from '@/store'
import styles from './index.module.less'

/* 免登模块 */
export const UnLogin: FC<any> = () => {
    const dispatch = useStoreDispatch();
    const [getRoles] = useSelectRole();

    useEffect(() => {
        let sdk = getUrlParam('sdk');
        let userInfo = getUrlParam('userInfo') || getUrlParam('userinfo');
        let appId = getUrlParam('appid');
        let ticket = getUrlParam('ticket');
        if (userInfo) {
            unLoginVerify({
                sdk,
                userInfo,
                appId,
                ticket,
                type: ticket ? 6 : 4,
                callBack: (res) => {
                    dispatch(res)
                    getRoles()
                }
            })
        }
    })

    return <div className={styles.unlogin}>
        <SpinLoading color='primary' style={{ '--size': '47px' }} />
        <p>Logging in ...</p>
    </div>
}
